var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeekW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_736_74)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 4.5,
    width: 35,
    height: 35,
    rx: 5.5,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 1.8125V7.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 1.8125V7.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.404785 14.875H37.192",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6714 29.724C11.1494 29.724 10.6994 29.64 10.3214 29.472C9.94937 29.298 9.60737 29.037 9.29537 28.689L10.2134 27.78C10.4174 28.014 10.6424 28.197 10.8884 28.329C11.1404 28.455 11.4314 28.518 11.7614 28.518C12.0614 28.518 12.2924 28.464 12.4544 28.356C12.6224 28.248 12.7064 28.098 12.7064 27.906C12.7064 27.732 12.6524 27.591 12.5444 27.483C12.4364 27.375 12.2924 27.282 12.1124 27.204C11.9384 27.126 11.7434 27.051 11.5274 26.979C11.3174 26.907 11.1074 26.826 10.8974 26.736C10.6874 26.64 10.4924 26.523 10.3124 26.385C10.1384 26.241 9.99737 26.064 9.88937 25.854C9.78137 25.638 9.72737 25.368 9.72737 25.044C9.72737 24.654 9.82037 24.318 10.0064 24.036C10.1984 23.754 10.4624 23.541 10.7984 23.397C11.1344 23.247 11.5214 23.172 11.9594 23.172C12.4034 23.172 12.8084 23.25 13.1744 23.406C13.5464 23.562 13.8524 23.775 14.0924 24.045L13.1744 24.954C12.9824 24.756 12.7874 24.609 12.5894 24.513C12.3974 24.417 12.1784 24.369 11.9324 24.369C11.6864 24.369 11.4914 24.417 11.3474 24.513C11.2034 24.603 11.1314 24.735 11.1314 24.909C11.1314 25.071 11.1854 25.203 11.2934 25.305C11.4014 25.401 11.5424 25.485 11.7164 25.557C11.8964 25.629 12.0914 25.701 12.3014 25.773C12.5174 25.845 12.7304 25.929 12.9404 26.025C13.1504 26.121 13.3424 26.244 13.5164 26.394C13.6964 26.538 13.8404 26.724 13.9484 26.952C14.0564 27.174 14.1104 27.45 14.1104 27.78C14.1104 28.386 13.8944 28.863 13.4624 29.211C13.0304 29.553 12.4334 29.724 11.6714 29.724ZM15.0104 29.625V23.271H16.4234V29.625H15.0104ZM16.0904 29.625V28.401H19.5734V29.625H16.0904ZM16.0904 26.97V25.791H19.2584V26.97H16.0904ZM16.0904 24.486V23.271H19.5284V24.486H16.0904ZM20.5475 29.625V23.271H21.5555L24.0575 27.168H23.5445L26.0375 23.271H27.0545V29.625H25.6415V25.656L25.8935 25.719L24.2645 28.257H23.3285L21.7085 25.719L21.9515 25.656V29.625H20.5475Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_736_74",
    x: -4,
    y: -3.1875,
    width: 46,
    height: 48.1875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_736_74"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_736_74",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekW);
export default __webpack_public_path__ + "static/media/weekW.549257a1320774649eea73ffec944eae.svg";
export { ForwardRef as ReactComponent };